<template>
    <div class="main" id="content">
        <appdown position="absolute" />
        <seat/>
        <div class="article-container">
            <div class="article-content">
                <conTent/>
                <morelist/>
                <comment/>
            </div>
            <toolbar/>
          </div>
    </div>
</template>

<script>
import conTent from "./content.vue"
import morelist from "../../components/programme/morelist.vue"
import comment from "../../components/programme/comment.vue"
import toolbar from "../../components/programme/toolbar.vue"
import appdown from "../../components/programme/appdown.vue"
import seat from "../../components/programme/seat.vue"
export default {
    name: "programme",
    components: {
        conTent,
        morelist,
        comment,
        toolbar,
        appdown,
        seat
    },
    data () {
        return {
        }
    },
    created () {
    },
    methods: {
    }
}
</script>

<style scoped>
@import url("../../assets/css/_h5.min.css");
</style>
